module.exports = __webpack_public_path__ + "img/default-img-3.611fc6e4.jpg";